// frontend/src/services/superadminService.js
import api from './api';

const unwrap = (p) => p.then((r) => r.data).catch((e) => { throw e.response?.data || e; });

const superadminService = {
  getCuentas: () => unwrap(api.get('/superadmin/cuentas/')),
  crearCuenta: (data) => unwrap(api.post('/superadmin/cuentas/', data)),
  getCuenta: (id) => unwrap(api.get(`/superadmin/cuentas/${id}/`)),
  actualizarCuenta: (id, data) => unwrap(api.patch(`/superadmin/cuentas/${id}/`, data)),
  agregarUsuario: (cuentaId, userId, tipoUsuarioId) =>
    unwrap(api.post(`/superadmin/cuentas/${cuentaId}/usuarios/`, { user_id: userId, tipo_usuario_id: tipoUsuarioId })),
  crearUsuario: (cuentaId, data) => unwrap(api.post(`/superadmin/cuentas/${cuentaId}/usuarios/crear/`, data)),
  cambiarTipo: (cuentaId, userId, tipoUsuarioId) =>
    unwrap(api.patch(`/superadmin/cuentas/${cuentaId}/usuarios/${userId}/`, { tipo_usuario_id: tipoUsuarioId })),
  quitarUsuario: (cuentaId, userId) => unwrap(api.delete(`/superadmin/cuentas/${cuentaId}/usuarios/${userId}/`)),
  buscarUsuarios: (q) => unwrap(api.get('/superadmin/usuarios/buscar/', { params: { q } })),
  getTipos: () => unwrap(api.get('/superadmin/tipos-usuario/')),
};

export default superadminService;
